import React from 'react';
import { motion } from 'framer-motion';
interface ToggleProps {
  isOn: boolean;
  onToggle: () => void;
  label?: string;
}
export function Toggle({
  isOn,
  onToggle,
  label
}: ToggleProps) {
  return <div className="flex items-center justify-between cursor-pointer" onClick={onToggle} data-id="element-100">
      {label && <span className="text-text font-medium" data-id="element-101">{label}</span>}
      <div className={`w-12 h-7 flex items-center rounded-full p-1 transition-colors duration-300 ${isOn ? 'bg-primary' : 'bg-gray-300 dark:bg-slate-600'}`} data-id="element-102">
        <motion.div className="bg-white w-5 h-5 rounded-full shadow-sm" animate={{
        x: isOn ? 20 : 0
      }} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} data-id="element-103" />
      </div>
    </div>;
}